/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landskin_4_TitleInputs */

const en_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soda Ripple`)
};

const ar_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صودا ريبل`)
};

const de_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soda-Welle`)
};

const es_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Burbujeo de soda`)
};

const fr_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondulation Soda`)
};

const it_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blu Frizzante`)
};

const ja_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソーダウェーブ`)
};

const ko_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`청량한 파도`)
};

const pt_br_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onda tônica`)
};

const ru_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Содовая рябь`)
};

const th_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกลียวคลื่นโซดา`)
};

const tr_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soda Dalgası`)
};

const zh_cn_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`苏打涟漪`)
};

const zh_tw_landskin_4_title = /** @type {(inputs: Landskin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蘇打漣漪`)
};

/**
* | output |
* | --- |
* | "Soda Ripple" |
*
* @param {Landskin_4_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const landskin_4_title = /** @type {((inputs?: Landskin_4_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landskin_4_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landskin_4_title(inputs)
	if (locale === "ar") return ar_landskin_4_title(inputs)
	if (locale === "de") return de_landskin_4_title(inputs)
	if (locale === "es") return es_landskin_4_title(inputs)
	if (locale === "fr") return fr_landskin_4_title(inputs)
	if (locale === "it") return it_landskin_4_title(inputs)
	if (locale === "ja") return ja_landskin_4_title(inputs)
	if (locale === "ko") return ko_landskin_4_title(inputs)
	if (locale === "pt_br") return pt_br_landskin_4_title(inputs)
	if (locale === "ru") return ru_landskin_4_title(inputs)
	if (locale === "th") return th_landskin_4_title(inputs)
	if (locale === "tr") return tr_landskin_4_title(inputs)
	if (locale === "zh_cn") return zh_cn_landskin_4_title(inputs)
	return zh_tw_landskin_4_title(inputs)
});